export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 mx-3 md:mx-6 my-3 md:my-6 rounded-2xl md:rounded-3xl overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20pastel%20toned%20fashion%20and%20lifestyle%20accessories%20artistic%20flatlay%20with%20white%20sneakers%20neutral%20caps%20cream%20hoodies%20arranged%20artistically%20on%20warm%20cream%20textured%20background%20minimal%20clean%20aesthetic%20editorial%20photography%20bright%20airy%20lighting%20harmonious%20composition%20gentle%20shadows&width=1600&height=900&seq=hero-gtbuy-main-2026&orientation=landscape"
          alt="GTBuy Sheet - Spreadsheet Shopping Platform"
          title="GTBuy Sheet Spreadsheet Shopping Guide"
          className="w-full h-full object-cover object-top"
        />
        {/* Dark overlay for text contrast */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/35"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <div className="mb-6">
          <span className="inline-block px-5 py-2 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 text-white text-xs md:text-sm font-medium tracking-wider uppercase whitespace-nowrap">
            Updated 2026 · Verified Daily
          </span>
        </div>

        <h1 className="font-heading text-5xl md:text-7xl xl:text-8xl font-bold text-white leading-[1.08] max-w-4xl">
          GTBuy Sheet
        </h1>
        <p className="mt-4 md:mt-6 text-base md:text-lg text-white/85 font-light max-w-xl leading-relaxed">
          The ultimate spreadsheet shopping experience. Browse verified items across
          14 curated categories &mdash; updated daily with fresh deals.
        </p>

        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 rounded-full text-sm md:text-base font-semibold bg-white text-foreground-900 hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
          >
            GTBuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 rounded-full text-sm md:text-base font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}